import BaseApi from '@/api/base-api'

class MerchantLendingApi extends BaseApi {
  fetchCurrentApplication = ({ userId } = {}) => {
    return this.request(
      {
        method: 'GET',
        path: '/merchants/business-banking/loans/applications/current',
      },
      {
        options: {
          headers: {
            'x-user-id': userId || '',
          },
        },
      }
    )
  }

  fetchActiveSoftOffer = ({ userId } = {}) => {
    return this.request(
      {
        method: 'GET',
        path:
          '/merchants/business-banking/loans/underwriting/soft-offer/active',
      },
      {
        options: {
          headers: {
            'x-user-id': userId || '',
          },
        },
      }
    )
  }
}

export default new MerchantLendingApi()
